module.exports = __webpack_public_path__ + "static/media/1.06ae4d89.png";